import { Dialog } from "primereact/dialog";
import { useState, forwardRef } from "react";
import Langs from "../../../app/lang/langs";
import { useDispatch, useSelector } from "react-redux";
import { InputText } from "primereact/inputtext";
import { DynamicButton } from "../../../components/buttons/DynamicButton";
import { Col, Row } from "react-bootstrap";
import { showErrorToast, showSuccessToast } from "../../../app/utils/helpers";
import { addEditSkill, getSkillsSettings } from "../../../components/clients/clientsSlice";
import {
    Dialog as MuiDialog,
    TextField,
    Button,
    IconButton,
    Slide,
    AppBar,
    Toolbar,
    Typography,
    Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function AddSkillModal(props) {

    const dispatch = useDispatch()
    const isMobile = useSelector((state) => state.settings.isMobile)
    const [name, setName] = useState('');
    const [flag, setFlag] = useState(false)

    const handleClose = () => {
        props.setVisible(false);
        setName('')
        setFlag(false)
    }

    const handleAdd = () => {
        if (name.trim() === '') {
            setFlag(true)
        } else {
            dispatch(addEditSkill({ name: name })).then((actionResponse) => {
                if (addEditSkill.fulfilled.match(actionResponse)) {
                    if (actionResponse.payload.responseData && actionResponse.payload.responseData.status) {
                        dispatch(getSkillsSettings());
                        showSuccessToast(actionResponse.payload.responseData.message);
                    }
                }
                if (actionResponse.payload.responseData.status === 0) {
                    showErrorToast(actionResponse.payload.responseData.message);
                }
            })
            handleClose()
        }
    }

    if (isMobile === 2) {
        return (
            <MuiDialog
                fullScreen
                open={!!props.visible}
                onClose={handleClose}
                slots={{ transition: Transition }}
                sx={{ zIndex: 1400 }}
            >
                <AppBar sx={{ position: "sticky", bgcolor: "#fff", color: "#222", boxShadow: "0 1px 8px rgba(0,0,0,0.08)" }} elevation={0}>
                    <Toolbar>
                        <IconButton edge="start" onClick={handleClose} sx={{ color: "#555" }}>
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ flex: 1, fontWeight: 600, fontSize: "1.05rem", color: "#222" }}>
                            <Langs str="ADD_SKILL" />
                        </Typography>
                    </Toolbar>
                </AppBar>
                <Box sx={{ p: 3, display: "flex", flexDirection: "column", gap: 3 }}>
                    <TextField
                        fullWidth
                        autoFocus
                        label={<Langs str="Nom" />}
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        error={flag}
                        helperText={flag ? <Langs str="Ce champ est requis" /> : ""}
                        onKeyDown={(e) => e.key === "Enter" && handleAdd()}
                        slotProps={{ input: { style: { fontSize: "16px" } } }}
                        sx={{
                            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#FF9015" },
                            "& .MuiInputLabel-root.Mui-focused": { color: "#FF9015" },
                        }}
                    />
                    <Button
                        fullWidth
                        variant="contained"
                        size="large"
                        startIcon={<AddIcon />}
                        onClick={handleAdd}
                        sx={{
                            bgcolor: "#FF9015",
                            color: "#fff",
                            fontWeight: 700,
                            fontSize: "1rem",
                            borderRadius: "12px",
                            py: 1.5,
                            textTransform: "none",
                            boxShadow: "0 4px 16px rgba(255,144,21,0.35)",
                            "&:hover": { bgcolor: "#e07800" },
                        }}
                    >
                        <Langs str="ADD" />
                    </Button>
                </Box>
            </MuiDialog>
        )
    }

    const body = () => {
        return (
            <Row className="p-2">
                <Col lg={9}>
                    <InputText invalid={flag} style={{ width: "80%" }} value={name} onChange={(e) => setName(e.target.value)} />
                </Col>
                <Col lg={3}>
                    <DynamicButton
                        onClick={() => handleAdd()}
                        className=''
                        title={<Langs str="ADD" />}
                        active={true}
                        color="green"
                    />
                </Col>
            </Row>
        )
    }

    return (
        <Dialog
            visible={props.visible}
            style={{ width: '50rem' }}
            onHide={() => { if (!props.visible) return; handleClose() }}
            position="center"
            draggable={false}
            header={<Langs str="ADD_SKILL" />}
        >
            {body()}
        </Dialog>
    )
}
